const VideoList = () => import('../../views/video/VideoList.vue');
const VideoEdit = () => import('../../views/video/VideoEdit.vue');
const VideoClassList = () => import('../../views/video/VideoClassList.vue');
const VideoClassEdit = () => import('../../views/video/VideoClassEdit.vue');
const VideoByClassList = () => import('../../views/video/VideoByClassList.vue');

const Container = {
  template: `
    <div class="Container">
      <router-view></router-view>
    </div>
  `,
};

const router = {
  path: '/video/productList',
  name: 'VideoContainer',
  component: Container,
  meta: {
    title: '视频管理',
    icon: 'video-play',
  },
  children: [
    {
      path: '/video/videoList',
      name: 'VideoListContainer',
      component: Container,
      meta: {
        title: '视频素材库',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'VideoList',
          component: VideoList,
          meta: {
            title: '视频列表',
          },
        },
        {
          path: '/video/videoAdd',
          name: 'VideoAdd',
          component: VideoEdit,
          meta: {
            title: '视频新增',
            light: '/video/videoList',
          },
        },
        {
          path: '/video/videoEdit/:videoId',
          name: 'VideoEdit',
          component: VideoEdit,
          meta: {
            title: '视频编辑',
            light: '/video/videoList',
          },
        },
      ],
    },
    {
      path: '/video/videoClassList',
      name: 'VideoClassListContainer',
      component: Container,
      meta: {
        title: '科普视频分类',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'VideoClassList',
          component: VideoClassList,
          meta: {
            title: '科普视频分类列表',
          },
        },
        {
          path: '/video/videoClassAdd',
          name: 'VideoClassAdd',
          component: VideoClassEdit,
          meta: {
            title: '科普视频分类新增',
            light: '/video/videoClassList',
          },
        },
        {
          path: '/video/videoClassEdit/:classId',
          name: 'VideoClassEdit',
          component: VideoClassEdit,
          meta: {
            title: '科普视频分类编辑',
            light: '/video/videoClassList',
          },
        },
      ],
    },
    {
      path: '/video/videoByClassList',
      name: 'VideoByClassListContainer',
      component: Container,
      meta: {
        title: '科普视频列表',
        hideChildren: true,
      },
      children: [
        {
          path: '',
          name: 'VideoByClassList',
          component: VideoByClassList,
          meta: {
            title: '科普视频列表',
            light: '/video/videoByClassList',
          },
        },
      ],
    },
  ],
};
export default router;



// WEBPACK FOOTER //
// ./src/router/modules/video.js